import React, { useEffect, useState } from "react";
import axios from "../../axios";
import { hashUrl } from "../../utils/file";
import pLimit from "p-limit";
import Skeleton from "@mui/material/Skeleton";

const limit = pLimit(1);

// The resized CDN copy ImageResizable loads for `src` (falls back to `src` on error).
export const resizedImageUrl = (src, size = "m") =>
  `https://d1puf2nnbcyl9q.cloudfront.net/${hashUrl(src)}-${size}`;

export const ImageResizable = ({ size = "m", fadeIn = false, src, asChild, ...props }) => {
  const [imageSrc, setImageSrc] = useState(
    "https://d1puf2nnbcyl9q.cloudfront.net/image_2024-10-09_18-02-12.png"
  );
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (src) {
      setImageSrc(resizedImageUrl(src, size));
      setIsLoading(false);
    }
  }, [src, size]);

  const handleImageError = async (e) => {
    setImageSrc(src);
    setIsLoading(false);

    // don't do this heavy task on prod as it can crash the system
    if (process.env.NODE_ENV === "production") {
      return;
    }

    limit(async () => {
      try {
        const response = await axios.post("/v1/upload/imageCompressionRemote", {
          url: src,
        });

        if (response.data && response.data.compressedImage) {
          const compressedUrlForSize = response.data.compressedImage[size];
          if (compressedUrlForSize) {
            setImageSrc(compressedUrlForSize);
          }
        }
      } catch (error) { }
    });
  };

  const Content = (
    <>
      <img
        src={imageSrc}
        onError={(e) => handleImageError(e, src)}
        data-original-src={src}
        loading="lazy"
        {...props}
        style={{
          opacity: fadeIn || isLoading ? 0 : 1,
          transition: fadeIn ? "opacity 0.3s ease-in-out" : undefined,
          ...props.style,
        }}
        onLoad={(e) => {
          setIsLoading(false);
          if (fadeIn) {
            e.target.style.opacity = 1;
          }
          if (props.onLoad) props.onLoad(e);
        }}
      />
    </>
  );

  if (asChild) {
    return Content;
  }

  return <>{Content}</>;
};
